import { render } from "./PlaqueTermsOfUseView.vue?vue&type=template&id=3f263d58"
import script from "./PlaqueTermsOfUseView.vue?vue&type=script&lang=js"
export * from "./PlaqueTermsOfUseView.vue?vue&type=script&lang=js"

import "./PlaqueTermsOfUseView.vue?vue&type=style&index=0&id=3f263d58&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__